import internshipService from "@/services/internship";
import { useAsyncState } from "@vueuse/core";

export const useGetInternship = (asyncStateOptions) =>
  useAsyncState(
    (internshipId) => internshipService.getOne(internshipId),
    [],
    asyncStateOptions
  );
